import React from 'react';
import { has, is } from '../../services/classify';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Slice Component
 * @deprecated
 * @param children {React.ReactNode} Children for Slice
 * @param onClick {Function} onClick Event Slice
 * ------------------ WEB PROPERTIES ---------------------
 * @param disabled {boolean} Disabled Slice
 * @param longCta {boolean} Change to the CTA line
 * @param selectable {boolean} Apply Field, Control classes wrapped
 * @param className {string} Additionnal CSS Classes
 */
const Slice = ({ children, className, onClick, disabled, longCta, selectable, testId, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('slice', disabled && is('disabled'), longCta && has('long-cta'), className));
    if (selectable) {
        return (React.createElement("div", { "data-testid": testId, onClick: onClick && onClick, className: classes, ...others },
            React.createElement("div", { className: hashClass(styled, clsx('field')) },
                React.createElement("div", { className: hashClass(styled, clsx('control')) }, children))));
    }
    return (React.createElement("div", { onClick: onClick && onClick, className: classes, ...others }, children));
};
export default Slice;
//# sourceMappingURL=Slice.js.map